/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Reply from '@spectrum-icons/workflow/Reply';
import { EditorState, convertFromRaw, Editor } from 'draft-js';
import ThumbUp from '@spectrum-icons/workflow/ThumbUp';
import ChevronDown from '@spectrum-icons/workflow/ChevronDown';
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';
import {
  ActionButton,
  MenuTrigger,
  Menu,
  Text,
  Item,
  Tooltip,
  TooltipTrigger,
} from '@adobe/react-spectrum';
import moment from 'moment';
import More from '@spectrum-icons/workflow/More';
import Share from '@spectrum-icons/workflow/Share';
import copy from 'copy-to-clipboard';
import Replies from './Replies';
import { Avatar } from './CommentStyle';
import getUserInitials from '../../utils/getUserInitials';
import { getLocalDateTime } from '../../utils/utils';

function Comments(props) {
  const {
    taskID,
    isTaskComment,
    project,
    entryDate,
    owner,
    replies,
    proofId,
    ID,
    workfrontEndpoint,
    documentID,
    commentRichText,
  } = props;
  const [replyArrow, setReplyArrow] = useState(false);
  const [userNameData, setUserNameData] = useState(true);
  const [projectNameData, setProjectNameData] = useState(true);

  const handleReplyArrow = () => {
    setReplyArrow(!replyArrow);
  };

  const handleDateAndTime = data => {
    const date = moment(data).format('DD-MM-YYYY');
    const time = `${moment(data).hour()}:${moment(data).minute()}`;
    return `${date} At ${time}`;
  };

  const getWorkfrontLinks = () => {
    if (proofId) {
      return `${workfrontEndpoint}/document/proof/${
        documentID || ''
      }/${proofId}/comment/${ID || ''}`;
    }
    if (documentID !== null) {
      return `${workfrontEndpoint}/document/${documentID || ''}/updates`;
    }
    if (isTaskComment) {
      return `${workfrontEndpoint}/task/${taskID}/updates?commentID=${
        ID || ''
      }`;
    }
    return `${workfrontEndpoint}/project/${
      project?.ID || ''
    }/updates?commentID=${ID || ''}`;
  };

  const toggleUserNameData = () => {
    setUserNameData(!userNameData);
  };

  const workfrontLink = getWorkfrontLinks();

  const commentdata = EditorState.createWithContent(
    convertFromRaw(JSON.parse(commentRichText)),
  );

  return (
    <div className="mainComment">
      <div className="headComment">
        <div className="logo">
          <Avatar>{getUserInitials(owner.name)}</Avatar>
        </div>
        <div className="nameParent">
          <div className="nameSectionUp">
            <h3 className="userName">
              <TooltipTrigger delay={0} placement="end">
                <ActionButton isQuiet>
                  {project?.name && projectNameData
                    ? project?.name.slice(0, 12)
                    : project?.name}
                  {projectNameData && project?.name?.length > 12 ? '...' : ''}
                </ActionButton>
                <Tooltip>{project?.name}</Tooltip>
              </TooltipTrigger>
            </h3>
            <span className="commentDate">
              {handleDateAndTime(getLocalDateTime(entryDate))}
            </span>
          </div>
          <div className="nameSectionDp">
            <span className="projectName">
              {owner?.name && userNameData
                ? owner?.name.slice(0, 15)
                : owner?.name}
              <span onMouseOver={toggleUserNameData}>
                {userNameData && owner?.name?.length > 15 ? '...' : ''}
              </span>
            </span>
            <MenuTrigger>
              <ActionButton isQuiet height="16px">
                <More />
              </ActionButton>
              <Menu
                onAction={() => {
                  copy(workfrontLink);
                }}
              >
                <Item key="threadLink" textValue="Copy thread link">
                  <Share size="XXL" />
                  <Text>Copy thread link</Text>
                </Item>
              </Menu>
            </MenuTrigger>
          </div>
        </div>
      </div>
      <div className="commentSection">
        <div className="commentBox">
          <div className="textArea">
            <a
              className="link-class"
              href={workfrontLink}
              target="_blank"
              rel="noreferrer"
            >
              <Editor editorState={commentdata} readOnly />
            </a>
          </div>
          <div className="iconArea">
            <span>
              <Reply size="XS" />
            </span>
            <span className="secondIcon">
              <ThumbUp size="XS" />
            </span>
          </div>
        </div>
      </div>
      <div className="replyButton">
        <ActionButton
          UNSAFE_className="_spectrum-ActionButton-label_7a745"
          isQuiet
          onPress={() => handleReplyArrow()}
        >
          {replyArrow ? (
            <ChevronRight width="12px" />
          ) : (
            <ChevronDown width="12px" />
          )}
          {replyArrow ? (
            <p className="_spectrum-ActionButton-label_7a745">View replies</p>
          ) : (
            <p className="_spectrum-ActionButton-label_7a745">Hide replies</p>
          )}
        </ActionButton>
      </div>
      {!replyArrow && replies.length > 0
        ? replies
            .reverse()
            .slice(0, 2)
            .map((data, index) => (
              <Replies
                key={data.ID + index}
                repliesID={data.ID}
                workfrontEndpoint={workfrontEndpoint}
                projectId={project?.ID}
                replies={data}
                handleDateAndTime={handleDateAndTime}
              />
            ))
        : ''}
    </div>
  );
}

export default Comments;
